<template>
  <div class="member_detail" v-loading="loading">
    <back />
    <div class="s_wrapper">
      <el-cascader class="" v-model="type" :options="options1" placeholder="项目分类" :props="propsOptions" @change="onChange" collapse-tags clearable></el-cascader>
      <el-input class="s_input" v-model="name" placeholder="请输入项目名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-select class="s_input" v-model="status" placeholder="请选择项目状态" @change="onChange" clearable>
        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="550">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="projectName" label="项目名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="createdTime" label="付款时间"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="categoryName" label="分类"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="price" label="定价(元)"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="durationMinute" label="服务时长(分钟)"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="90" prop="projectCount" label="总次数"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="90" prop="count" label="剩余次数"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" label="项目状态">
          <template slot-scope="scope">
            <span :class="scope.row.projectStatus == 2 ? 'project_status' : ''">{{ mapCouponType(scope.row.projectStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.projectStatus == 1" type="primary" plain @click="verification(scope.row)">核销</el-button>
            <el-button type="primary" plain @click="handleAddService(scope.row)">增加服务次数</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :destroy-on-close="true">
      <!-- 选择员工 -->
      <div class="dialog_employee">
        <!-- <div class="verify_code_order">
          <div class="order_info">
            <div>订单号：{{ order.orderCode }}</div>
            <div>用户姓名：{{ order.userName }}</div>
            <div>联系电话：{{ order.userPhone }}</div>
          </div>
          <div class="project">项目名称：{{ order.projectName }}</div>
        </div> -->
        <el-tabs class="tabs" v-model="departmentId" @tab-click="handleClickEmployeeTabs">
          <el-tab-pane v-for="(item, index) in staffDepartmentList" :key="index" :label="item.departmentName" :name="item.departmentId"></el-tab-pane>
        </el-tabs>
        <el-empty class="empty" v-if="staffList.length == 0" description="暂无数据"></el-empty>
        <div class="employee_list" v-else v-loading="employeeloading">
          <div class="employee_list_item" v-for="(item, index) in staffList" :key="index" :class="employeeId == item.employeeId ? 'employee_ac' : ''" @click="changeStaff(item)">
            <div class="icon">
              <i class="el-icon-success" v-if="employeeId == item.employeeId"></i>
              <i class="el-icon-circle-check" v-else></i>
            </div>
            <div class="avatar">
              <img :src="item.picUrl || require('@/assets/img/staff.png')" width="60" height="60" />
            </div>
            <div class="info">
              <div class="name overt">{{ item.employeeName }}</div>
              <div class="code overt">员工编号：{{ item.employeeCode }}</div>
              <div class="num">今日服务次数：{{ item.count }}次</div>
            </div>
          </div>
        </div>

        <el-pagination class="pg_input" background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize2" :page-sizes="pageSizeArr2" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount2"></el-pagination>
      </div>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onConfirm" :loading="btnloading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      name: "",
      type: "",
      status: "",
      options1: [],
      options2: [
        { value: "1", label: "未完成" },
        { value: "2", label: "已完成" },
      ],
      propsOptions: {
        expandTrigger: "hover",
        label: "categoryName",
        value: "categoryId",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      dialogVisible: false,
      btnloading: false,
      employeeloading: false,
      dialogTitle: "订单核销",
      departmentId: "",
      employeeId: "",
      employeeName: "",
      order: {},
      staffDepartmentList: [],
      staffList: [],
      // 员工分页
      currentPage2: 1, // 当前页码
      pageSize2: 9, // 每页显示的行数
      pageSizeArr2: [9, 18, 54], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getCategoryInfoList()
    this.getPurchasedList()
  },
  methods: {
    mapCouponType(val) {
      return this.options2.find(e => e.value == val)?.label || ""
    },
    // 分类
    getCategoryInfoList() {
      this.$axios
        .get(this.$api.projectInfoselectProjectCategoryList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          this.options1 = res.result
          // this.options1.map(item => {
          //   if (item.children.length == 0) {
          //     item.children = null
          //   }
          // })
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    getPurchasedList() {
      this.loading = true
      this.$axios
        .post(this.$api.memberInfomemberPurchasedPageList, {
          userId: Number(this.$route.query.id),
          projectName: this.name || null,
          projectStatus: this.status || null,
          categoryIdList: this.type.length > 0 ? this.type : null,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getPurchasedList()
    },
    onChange() {
      this.tableData = []
      this.currentPage = 1
      this.getPurchasedList()
    },
    verification(e) {
      this.order = e
      this.dialogVisible = true
      this.departmentId = "0"
      this.currentPage2 = 1
      this.employeeId = ""
      this.employeeName = ""
      this.getStaffList()
      this.getStaffDepartmentList()
    },
    // 增加服务次数
    handleAddService(row) {
      this.$prompt("请输入增加服务次数", "增加服务次数", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+$/,
        inputErrorMessage: "格式不正确，请输入正整数",
        inputPlaceholder: "请输入正整数",
      })
        .then(({ value }) => {
          this.$axios
            .post(this.$api.memberInfoaddServiceCount, {
              id: row.itemId,
              addCount: Number(value),
            })
            .then(res => {
              this.$message.success(`增加成功，增加服务次数: ${value} 次`)
              this.getPurchasedList()
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 员工列表
    getStaffList() {
      this.employeeloading = true
      this.$axios
        .get(this.$api.employeeInfoselectEmployee, {
          params: {
            parentId: this.departmentId == "0" ? "" : this.departmentId,
            storeId: this.$store.state.userInfo.bizId,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          this.staffList = res.result.list
          this.totalItemsCount2 = res.result.totalCount
          this.employeeloading = false
        })
        .catch(err => {
          this.employeeloading = false
          this.$message.error(err.desc)
        })
    },
    // 员工部门
    getStaffDepartmentList() {
      this.$axios
        .get(this.$api.departmentInfoselectParentDepartment)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              departmentId: e.departmentId.toString(),
            }
          })
          list.unshift({ departmentId: "0", departmentName: "全部" })
          this.staffDepartmentList = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 切换员工部门
    handleClickEmployeeTabs() {
      this.staffList = []
      this.currentPage2 = 1
      this.getStaffList()
    },
    // 切换员工
    changeStaff(e) {
      this.employeeId = e.employeeId
      this.employeeName = e.employeeName
    },
    onCancel() {
      this.dialogVisible = false
      this.order = {}
    },
    onConfirm() {
      this.btnloading = true
      this.$axios
        .post(this.$api.store_project_reservation, {
          storeId: this.$store.state.userInfo.bizId,
          employeeId: this.employeeId,
          projectOrderItemId: this.order.itemId,
        })
        .then(res => {
          this.btnloading = false
          this.dialogVisible = false
          this.$message.success("核销成功")
          this.getPurchasedList()
        })
        .catch(err => {
          this.btnloading = false
          this.$message.error(err.desc)
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getPurchasedList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getPurchasedList()
    },
    // 切换每页显示的条数 - 员工
    handleSizeChange2(e) {
      this.staffList = []
      this.pageSize2 = e
      this.getStaffList()
    },
    // 换页 - 员工
    handleCurrentChange2(e) {
      this.staffList = []
      this.currentPage2 = e
      this.getStaffList()
    },
  },
}
</script>

<style scoped lang="scss">
.member_detail {
  .project_status {
    color: $themes;
  }
  .dialog_employee {
    .tabs {
      ::v-deep .el-tabs__nav-wrap::after {
        height: 0;
      }

      ::v-deep .el-tabs__item {
        font-size: 16px;
        padding: 0 15px;
      }

      ::v-deep .el-tabs__item.is-active {
        font-weight: bold;
      }

      ::v-deep .el-tabs__active-bar {
        height: 4px;
        border-radius: 10px;
      }
    }
    // .verify_code_order {
    //   display: flex;
    //   flex-direction: column;
    //   color: #707070;
    //   padding: 15px;
    //   margin-bottom: 20px;
    //   background: rgba(3, 16, 14, 0.05);
    //   border-radius: 10px 10px 10px 10px;
    //   .order_info {
    //     display: flex;
    //     justify-content: space-between;
    //     margin-bottom: 15px;
    //   }
    // }
    .empty {
      min-height: 300px;
    }
    .employee_list {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      min-height: 300px;

      .employee_list_item {
        display: flex;
        align-items: center;
        width: 295px;
        height: 95px;
        padding: 10px;
        margin-right: 15px;
        margin-bottom: 15px;
        font-size: 14px;
        color: #707070;
        background: #fff;
        box-shadow: 0px 3px 30px 1px rgba(38, 30, 3, 0.04);
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #e8e8e8;
        box-sizing: border-box;
        cursor: pointer;
        .icon {
          font-size: 20px;
        }
        .avatar img {
          border-radius: 50%;
          margin: 0 10px;
          object-fit: cover;
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 100%;
          .name {
            color: #0f1c40;
            font-weight: bold;
          }
          .overt {
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .employee_ac {
        color: $themes;
        border-color: $themes;
      }
    }
  }
}
</style>
